/**
 * First-visit gate.
 *
 * A fresh, logged-out visitor who lands on `/` is sent to `/welcome` exactly
 * once (tracked via a long-lived cookie). Authenticated users and repeat
 * visitors are never redirected, and `/welcome` itself is never gated. The gate
 * is additive — it does not touch Sanctum's `onAuthOnly` redirect target.
 */
export default defineNuxtRouteMiddleware((to) => {
  // SPA: only evaluate on the client where cookies/auth state are available.
  if (import.meta.server) return

  // Only the app root is gated; deep links and /welcome pass through untouched.
  if (to.path !== '/') return

  const seenWelcome = useCookie<boolean>('hotlot_seen_welcome', {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    path: '/',
    // Несенситивная UX-cookie, но в проде ходим только по https.
    secure: !import.meta.dev,
  })

  if (seenWelcome.value) return

  // Never gate authenticated players.
  const { isAuthenticated } = useSanctumAuth()
  if (isAuthenticated.value) {
    seenWelcome.value = true
    return
  }

  seenWelcome.value = true
  // src=gate — маркер для страховки в welcome.vue: если сюда по гонке попал
  // уже авторизованный игрок (медленный/упавший /player на холодном старте),
  // страница вернёт его на «/», как только auth-состояние прояснится.
  return navigateTo({ path: '/welcome', query: { src: 'gate' } })
})
